import { useStyles } from "./RCATicketNumber.styles";
import { IRCATicketNumber, IRCATicketTypeEnum } from "./RCATicketNumberInterfaces";
import IssueIcon from "pages/Corporate/RCA/images/issue_icon.svg";
import ActionPlanIcon from "pages/Corporate/RCA/images/action_plan_icon.svg";
import RCAIcon from "pages/Corporate/RCA/images/rca_icon.svg";

const RCATicketNumber = ({ ticketNumber, ticketType, className }: IRCATicketNumber) => {
    const classes = useStyles();

    const ticketIcon = {
        [IRCATicketTypeEnum.ISSUE]: IssueIcon,
        [IRCATicketTypeEnum.ACTION_PLAN]: ActionPlanIcon,
        [IRCATicketTypeEnum.RCA]: RCAIcon,
    };

    return (
        <div className={`${classes.mainWrapper} ${className ? className : ""}`}>
            <img src={ticketIcon[ticketType as keyof typeof ticketIcon]} alt="Ticket icon" />
            {ticketNumber}
        </div>
    );
};

export default RCATicketNumber;
